enum NewBusinessApplicationStatus {
	UNKNOWN = 'Unknown',
	NEW = 'New',
	IN_THE_WORKS = 'In The Works',
	REVIEW = 'Review',
	SUBMITTED = 'Submitted',
	APPROVED = 'Approved',
	APPROVED_PAID = 'ApprovedPaid',
	DECLINED = 'Declined',
	HOLD = 'Hold',
	EXPIRED_APPROVAL = 'Expired Approval',
	ARCHIVED = 'Archived',
	PROMOTED = 'Promoted',
}

export default NewBusinessApplicationStatus;